import React from "react";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";
import { RootState } from "../../store/root/config.store";

const LoaderOverlay: React.FC = () => {
  const isLoading = useSelector((state: RootState) => state?.loader?.isLoading);

  return (
    <Backdrop
      open={isLoading}
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.modal + 2,
        backgroundColor: "rgba(0, 0, 0, 0.4)",
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoaderOverlay;
